import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useEpiEcdRootPageContent } from '../../hooks/useEpiEcdRootPageContent';



export function MobileAppNavigation() {
    const [navToggle, setNavToggle] = useState('');
    const ecdRootPage = useEpiEcdRootPageContent();
    const location = useLocation()?.pathname;
    const openClass = 'nav-open';
    const toggle = () => {
        if (navToggle === openClass) {
            setNavToggle('');
            document.body.classList.remove(openClass);
        } else {
            setNavToggle(openClass);
            document.body.classList.add(openClass);
        }
    };
    if (!ecdRootPage?.navigationLinks) return null;

    function IsActiveRoute(linkUrl: string): boolean {
        return linkUrl && location?.toLowerCase().includes(linkUrl?.toLowerCase());
    }

    function RenderNavigationLink(props) {
        const { linkUrl, linkText } = props;

        if (!linkText) return null;

        return (<>
            <li key={linkText} className='ecd-mobile-nav-list-item'> <a href={linkUrl} className={`ecd-mobile-nav-list-item-link ${IsActiveRoute(linkUrl) ? 'active' : ''}`}>{linkText}</a></li>
        </>);
    }

    function RenderNavigationLinks() {
        if (!ecdRootPage?.navigationLinks) return null;

        return (


            <ul className='ecd-mobile-nav-list'>
                {ecdRootPage?.navigationLinks?.map((nl) => <RenderNavigationLink key={nl.linkUrl} linkUrl={nl.linkUrl} linkText={nl.linkText} />)}
            </ul>

        );
    }

    return (
        
        <nav className='ecd-mobile-nav'>
            <div className='ecd-mobile-nav-header'>
                <div className='ecd-mobile-nav-header-inner'>
                    <a href={ecdRootPage?.mobileLogoImageLink} className=''><img src={ecdRootPage?.mobileLogoImage} alt={ecdRootPage?.mobileLogoImageAltText} /></a>
                    </div>
                <button onClick={toggle} className='ecd-mobile-nav-trigger' type='button'> <svg className='info-icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#hamburger-icon' />
                </svg>{ecdRootPage.mobileMenuTriggerText &&  <span>{ecdRootPage?.mobileMenuTriggerText}</span>}</button>
            </div>
            <div className={`ecd-mobile-nav-panel  ${navToggle}`}>
                <RenderNavigationLinks />
                </div>
            </nav>
    );
}